import { take, fork, all } from 'redux-saga/effects';
import { apiTask, watchApiTask } from '../../app/sagas';
import { api } from '../../app/api';
import * as actions from './composingCorrectionActions';

export const getEvaluationInformationTask = watchApiTask(
  actions.GET_EVALUATION_INFORMATION,
  api.post,
  '/evaluation-system/getEvaluationInformation.php',
);

export const getStudentAnswerListTask = watchApiTask(
  actions.GET_STUDENT_ANSWER_LIST,
  api.post,
  '/evaluation-system/getStudentAnswerList.php',
);

export const uploadEvaluationEssayCardTask = watchApiTask(
  actions.UPLOAD_EVALUATION_ESSAY_CARD,
  api.post,
  '/evaluation-system/uploadEvaluationEssayCard.php',
);

// Root module saga
export function* sagas() {
  yield all([
    fork(getEvaluationInformationTask),
    fork(getStudentAnswerListTask),
    fork(uploadEvaluationEssayCardTask),
  ]);
}
